import React from 'react'
import Lifecycle from '@squarespace/core/Lifecycle'
import PageComponent from '../../components/Page'

class Blog extends React.Component {
  componentDidMount() {
    window.Squarespace = { afterBodyLoad: () => {} }
    Lifecycle.init()

    const images = Array.from(document.getElementsByTagName('IMG'))
    images.forEach(img => {
      if (img.dataset.src) {
        img.src = img.dataset.src
        img.parentNode.style.paddingBottom = 0
      }
    })
  }

  render() {
    const { items } = this.props.pageContext

    return (
      <PageComponent
        data={{
          component: (
            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              width: '90%',
              maxWidth: '1400px',
              margin: 'auto',
              justifyContent: 'space-between',
            }}>
              {items.map((item, i) => {
                return (
                  <div style={{ 
                    width: '48%', 
                    display: 'flex',
                    flexDirection: 'column',
                    marginBottom: '15rem',
                  }} key={i}>
                    <div style={{ 
                      backgroundImage: `url(${item.assetUrl})`, 
                      width: '100%',
                      height: '100rem',
                      backgroundSize: 'cover',
                    }} />
                    <h3 style={{ marginTop: '5rem' }}>
                      {item.title}
                    </h3>
                    <div dangerouslySetInnerHTML={{ __html: item.excerpt }} />
                    
                    <a href={`/blog/${item.urlId}`}>
                      <button>
                        Read More
                      </button>
                    </a>
                  </div>
                )
              })}
            </div>
          ),
          banner: {
            static: <h1>Blog</h1>,
          },
        }} 
      />
    )
  }
}

export default Blog